import React from 'react';

interface LoadingFallbackProps {
  fullPage?: boolean;
  label?: string;
}

/**
 * Branded loading spinner for Suspense boundaries.
 *
 * - `fullPage` — centers vertically in the viewport (route-level)
 * - default — fills its nearest container with a min height (modal/panel-level)
 */
export function LoadingFallback({ fullPage = false, label = 'Loading…' }: LoadingFallbackProps) {
  return (
    <div
      className={`flex items-center justify-center ${fullPage ? 'min-h-dvh' : 'h-full min-h-[200px]'}`}
      role="status"
      aria-label={label}
    >
      <div className="flex flex-col items-center gap-3">
        <div className="ally-spinner-ring h-8 w-8" />
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
    </div>
  );
}

export default LoadingFallback;
